import React from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import ResumeSubscriptionModal from '../../../../../components/settings/components/billing-subscription/components/resume-subscription-modal.tsx';
import { IProps } from './pause-lead-finder-manager-container';
import { RequestStatus } from '../../../../enums/request-status';
import { executeOnRequestStatusWithPrevStatusCheck } from '../../../execute-on-request-status';
import toaster, { Theme } from '../../../../toaster';
import { contactAdmin } from '../../../contact-admin';
import hasPermission from '../../../access-control/has-permission';
import { Permissions } from '../../../access-control/enums/permissions';
import { handle3dSecureCardPayment } from '../../../../components/handle-3d-secure-card-payment/handle3dSecureCardPayment';

type PauseLeadFinderManagerState = {
  showResumeLeadFinderSubscriptionModal: boolean;
  is3dSecureResponseStatePending: boolean;
};

class PauseLeadFinderManager extends React.Component<
  IProps,
  PauseLeadFinderManagerState
> {
  constructor(props) {
    super(props);

    this.state = {
      showResumeLeadFinderSubscriptionModal: false,
      is3dSecureResponseStatePending: false,
    };

    this.onCloseResumeSubscriptionModal = this.onCloseResumeSubscriptionModal.bind(
      this,
    );
    this.openResumeSubscriptionModal = this.openResumeSubscriptionModal.bind(
      this,
    );

    const { bindActions } = this.props;

    bindActions(this.openResumeSubscriptionModal);
  }

  componentDidUpdate(prevProps: Readonly<IProps>) {
    const {
      sendGetResumeLeadFinderSubscriptionStatus,
      sendGetUserSettingsRequest,
      sendGetUserSubscriptionMetadataRequest,
      resetResumeLeadFinderSubscriptionResponse,
      sendGetResumeLeadFinderSubscriptionError,
      sendGetResumeLeadFinderSubscriptionResponse,
    } = this.props;
    executeOnRequestStatusWithPrevStatusCheck({
      status: sendGetResumeLeadFinderSubscriptionStatus,
      prevStatus: prevProps.sendGetResumeLeadFinderSubscriptionStatus,
      onSuccess: () => {
        if (sendGetResumeLeadFinderSubscriptionResponse?.requires_action) {
          this.onCloseResumeSubscriptionModal();
          sendGetUserSubscriptionMetadataRequest();
          this.handle3dSecureCard(sendGetResumeLeadFinderSubscriptionResponse);
          toaster.error(sendGetResumeLeadFinderSubscriptionResponse?.message, {
            theme: Theme.New,
          });
        } else {
          this.onCloseResumeSubscriptionModal();
          sendGetUserSettingsRequest();
          sendGetUserSubscriptionMetadataRequest();
          resetResumeLeadFinderSubscriptionResponse();
          toaster.success(
            sendGetResumeLeadFinderSubscriptionResponse?.message,
            {
              theme: Theme.New,
            },
          );
        }
      },
      onFailed: () => {
        this.onCloseResumeSubscriptionModal();
        toaster.error(sendGetResumeLeadFinderSubscriptionError?.message);
      },
    });
  }

  onCloseResumeSubscriptionModal = () => {
    this.setState({
      showResumeLeadFinderSubscriptionModal: false,
    });
  };

  openResumeSubscriptionModal = () => {
    this.setState({
      showResumeLeadFinderSubscriptionModal: true,
    });
  };

  handle3dSecureCard = async (response) => {
    const {
      resetResumeLeadFinderSubscriptionResponse,
      sendGetUserSettingsRequest,
      sendGetUserSubscriptionMetadataRequest,
      t,
    } = this.props;

    this.setState({ is3dSecureResponseStatePending: true });
    const { isError } = await handle3dSecureCardPayment({
      response,
    });

    if (isError) {
      toaster.error(
        'Payment failed! Please retry again after some time from billing section.',
      );
    } else {
      sendGetUserSettingsRequest();
      sendGetUserSubscriptionMetadataRequest();
      resetResumeLeadFinderSubscriptionResponse();
      toaster.success(t('messages.resume_subscription_success_message'), {
        theme: Theme.New,
      });
    }
    this.setState({ is3dSecureResponseStatePending: false });
  };

  resumeSubscription = () => {
    const {
      sendResumeLeadFinderSubscriptionRequest,
      leadFinderCustomerId,
      t,
      firstName,
    } = this.props;

    const emailBody = `Hello ${firstName}, %0D%0A %0D%0A ${t(
      'messages.resume_subscription_email_body',
    )}`;
    if (hasPermission(Permissions.LEAD_FINDER_SUBSCRIPTION_READ)) {
      sendResumeLeadFinderSubscriptionRequest({
        customerId: leadFinderCustomerId,
      });
    } else {
      contactAdmin(t('messages.resume_subscription'), emailBody);
    }
  };

  render() {
    const {
      showResumeLeadFinderSubscriptionModal,
      is3dSecureResponseStatePending,
    } = this.state;
    const {
      sendGetResumeLeadFinderSubscriptionStatus,
      leadFinderPauseEndsAt,
    } = this.props;

    return (
      <ResumeSubscriptionModal
        show={showResumeLeadFinderSubscriptionModal}
        onClose={this.onCloseResumeSubscriptionModal}
        onResumeSubscription={this.resumeSubscription}
        pauseEndsDate={leadFinderPauseEndsAt}
        isRequestPending={
          sendGetResumeLeadFinderSubscriptionStatus === RequestStatus.Pending ||
          is3dSecureResponseStatePending
        }
        resumeSubscriptionModalMessage1={
          hasPermission(Permissions.LEAD_FINDER_SUBSCRIPTION_READ)
            ? 'resume_subscription_admin_message_one'
            : 'resume_subscription_member_message_one'
        }
        resumeSubscriptionModalMessage2={
          hasPermission(Permissions.LEAD_FINDER_SUBSCRIPTION_READ)
            ? 'resume_subscription_admin_message_two'
            : 'resume_subscription_member_message_two'
        }
        resumeSubscriptionModalHeaderMessage="subscription_paused"
        submitButtonText={
          hasPermission(Permissions.LEAD_FINDER_SUBSCRIPTION_READ)
            ? 'resume_subscription'
            : 'contact_admin'
        }
      />
    );
  }
}

export default withTranslation()(withRouter(PauseLeadFinderManager));
